import { Box } from "@wix/design-system";
import React, { useContext, useMemo, useState } from "react";
import { EditorContext, ModalServiceContext } from "./../../ricos-context";
import { Link_Target } from "./../../ricos-schema/legacy/wix/rich_content/v1";
import { FloatingLayout, FooterActions, LinkSettings } from "./../../ui-components";
import { useBiNext } from "../../_shared/bi-context-provider/bi-context-provider";
import { linkPreviewModals } from "../consts";
import { LINK_PREVIEW_TYPE } from "../types";
const SettingsModal = ({ nodeId }) => {
  const modalService = useContext(ModalServiceContext) || {};
  const { getPublicCommands } = useContext(EditorContext);
  const initialData = useMemo(
    () => getPublicCommands().getBlockComponentData(nodeId),
    []
  );
  const [componentData, setComponentData] = useState(initialData);
  const logBi = useBiNext({
    pluginId: "linkPreview",
    modalId: linkPreviewModals.settings,
    nodeId
  });
  const updateData = (data) => {
    getPublicCommands().setBlock(nodeId, LINK_PREVIEW_TYPE, {
      ...componentData,
      ...data
    });
    setComponentData({ ...componentData, ...data });
  };
  const closeModal = () => {
    modalService.closeModal(linkPreviewModals.settings);
  };
  const handleOnCancel = () => {
    updateData(initialData);
    closeModal();
  };
  return componentData ? /* @__PURE__ */ React.createElement(
    FloatingLayout,
    {
      onCloseButtonClick: handleOnCancel,
      content: {
        children: /* @__PURE__ */ React.createElement(Box, { padding: "SP4" }, /* @__PURE__ */ React.createElement(
          LinkSettings,
          {
            linkValue: {
              url: componentData.link?.url,
              openInNewTab: componentData.link?.target === Link_Target.BLANK,
              nofollow: componentData.link?.rel?.nofollow,
              noreferrer: componentData.link?.rel?.noreferrer,
              sponsored: componentData.link?.rel?.sponsored
            },
            options: {
              showInputField: false,
              showNewTabCheckbox: true,
              showNoReferrerCheckbox: true,
              showNoFollowCheckbox: true,
              showSponsoredCheckbox: true
            },
            onChange: (data) => {
              setComponentData((prev) => {
                const rel = data.nofollow || data.noreferrer || data.sponsored ? {
                  nofollow: getValueOrDefault(data.nofollow),
                  noreferrer: getValueOrDefault(data.noreferrer),
                  sponsored: getValueOrDefault(data.sponsored)
                } : void 0;
                return {
                  ...prev,
                  link: {
                    ...prev.link,
                    url: prev.link?.url,
                    anchor: prev.link?.anchor,
                    target: data.openInNewTab ? Link_Target.BLANK : Link_Target.TOP,
                    rel
                  }
                };
              });
            }
          }
        ))
      },
      footer: {
        children: /* @__PURE__ */ React.createElement(
          FooterActions,
          {
            onSave: () => {
              updateData(componentData);
              closeModal();
            },
            onCancel: handleOnCancel,
            logBi
          }
        )
      }
    }
  ) : null;
};
const getValueOrDefault = (value) => value ? value : void 0;
export {
  SettingsModal
};
//# sourceMappingURL=SettingsModal.js.map
